import { render, staticRenderFns } from "./SalesDelivery.vue?vue&type=template&id=5fef4c67&"
import script from "./SalesDelivery.vue?vue&type=script&lang=js&"
export * from "./SalesDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports